export default __webpack_public_path__ + "static/media/lobby-text.b57114f3.png";